import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, DIMENSION_META } from "@/lib/api";
import { Clock, CheckCircle2 } from "lucide-react";

export default function Lessons() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/lessons").then((r) => setItems(r.data)); }, []);

  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-12 py-10 fade-up">
      <div className="mb-10">
        <div className="text-xs uppercase tracking-widest text-slate-500 mb-1">Micro-practices, personalized</div>
        <h1 className="font-serif text-4xl text-[#0B1E36]">Microlearning library</h1>
        <p className="text-slate-600 mt-3 max-w-2xl">Ordered by what your diagnostic said matters most for you right now. 3–7 minutes each.</p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((l) => {
          const meta = DIMENSION_META[l.dimension];
          return (
            <Link key={l.id} to={`/app/lessons/${l.id}`} data-testid={`lesson-${l.id}`} className="bg-white rounded-2xl border border-slate-200 overflow-hidden card-lift group relative">
              {l.completed && (
                <div className="absolute top-4 right-4 z-10 bg-[#2C7A7B] text-white h-8 w-8 rounded-full grid place-items-center">
                  <CheckCircle2 className="h-4 w-4" />
                </div>
              )}
              <div className="h-36 overflow-hidden">
                <img src={l.cover} alt={l.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 text-xs mb-3">
                  <span className="uppercase tracking-widest font-semibold" style={{ color: meta.color }}>{meta.label}</span>
                  <span className="text-slate-300">•</span>
                  <span className="inline-flex items-center gap-1 text-slate-500"><Clock className="h-3 w-3" /> {l.duration_min} min</span>
                </div>
                <h3 className="font-serif text-lg text-[#0B1E36] mb-2 leading-snug">{l.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{l.summary}</p>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
